// Returns the selected option objects from a source question.
// sourceRef can be either the element id or the question id depending on how the flow was authored.
// We need both the elements (to locate the source question element and read its options)

import { uuid } from '../../../../../../server/helpers/uuid.helper';

// and the questions state (to read the live response by element id).
export function getOptionsFromSourceQuestion(sourceRef, elements, questionsState) {
  if (!sourceRef || !elements || !questionsState) return [];

  const questionElements = Object.values(elements).filter((el) => el.type === 'question');
  const sourceElement =
    questionElements.find((el) => el?.question?.id === sourceRef) ||
    questionElements.find((el) => el?.id === sourceRef);

  if (!sourceElement) return [];

  const sourceElementId = sourceElement.id; // element id is the key for questions state
  const sourceOptions = sourceElement.question?.options || [];
  const sourceResponse = questionsState[sourceElementId]?.response;

  if (!sourceResponse || (Array.isArray(sourceResponse) && sourceResponse.length === 0)) return [];

  const selectedOptionIds = Array.isArray(sourceResponse) ? sourceResponse : [sourceResponse];
  return sourceOptions
    .filter((option) => selectedOptionIds.includes(option.id))
    .map((option) => ({
      ...option,
      id: uuid(),
      key: uuid(),
      dynamic: true,
    }));
}
